import { useState, useEffect }                  from 'react';
import InputFileForm                            from './InputFileForm';

import { UseInputFile }                         from '../../contexts/InputFilePageContext';
import api                                      from '../../services/api';
import { useUser }                              from '../../contexts/UserContext.js';

function InputFileFormContainer() {
  
    const [ files,                   setFiles                   ] = useState([]);
    const [ demandTypes,             setDemandTypes             ] = useState(null);
    const [ selectedDemandHorizonId, setSelectedDemandHorizonId ] = useState(null);
    const [ errorMessage,            setErrorMessage            ] = useState(null);
    const [ loading,                 isLoading                  ] = useState(true);

    const { userData } = useUser();
    const { handleModalFileClose, handleUpdateDemandTable, isModalOpen } = UseInputFile();

    const handleFormSubmit = async (data) => {
  
        try {
            console.log("userData ", userData)
            setErrorMessage(null);
            const formData = new FormData();

            formData.append('excelFile', data.excelFile);
            formData.append('selectedDemandHorizonId', selectedDemandHorizonId.value);
            formData.append('userId', userData.id);

            const response = await api.post('/uploadDemandFile', formData);

            if (response.status == 200){
                handleModalFileClose();
                handleUpdateDemandTable();
            }
            else{
                setErrorMessage(response.data.message)
            }


        } catch (error) {
            console.log(error)
            setErrorMessage(error?.response?.data?.message || 'Erro ao enviar a demanda.');
        }
    };

    const fetchDemandTypeData = async () => {
    
        try {
        
            const response = await api.get('/getAllDemandHorizons');

            const formatted = response.data.map(item => ({
                value: item.id,
                label: item.ownerHorizonOfPlan.name,
            }));

            setDemandTypes(formatted);

            isLoading(true);

        } catch (error) {
            
            if (error.code === 'ECONNABORTED') {
                
                setErrorMessage('Erro ao carregar tipos de demanda: tempo limite excedido.');
            } else {

                setErrorMessage(error?.response?.data?.message || 'Erro ao carregar tipos de demanda.');
            }
        }
    };


    const handleChangeDemandType = (selectedOption) => {
        
        setSelectedDemandHorizonId(selectedOption);
    };

    const fetchDemandTypeTemplateFile = async () => {
        
        if (!selectedDemandHorizonId) return;

        try {
            
            const response = await api.get(`/getDemandHorizonTemplateFileName/${selectedDemandHorizonId.value}`,
                { responseType: 'blob' }
            );

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const contentDisposition    = response.headers['content-disposition'];
            const match                 = contentDisposition?.match(/filename="?(.+)"?/);
            const fileName              = match ? match[1] : 'template.xlsx';

            const url   = window.URL.createObjectURL(blob);
            const link  = document.createElement('a');
            
            link.href = url;
            link.setAttribute('download', fileName);
            
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            
            setErrorMessage('Erro ao baixar o template.');
        }
    };

    useEffect(() => {
        
        if (demandTypes) {
            
            setSelectedDemandHorizonId(demandTypes[0]);
        }

    }, [demandTypes]);

    useEffect(() => {
        if (isModalOpen) {
           
            const loadData = async () => {
                setErrorMessage(null);
                try {
                await fetchDemandTypeData();
                } finally {
                isLoading(false);
                }
            };

            loadData();
        }
    }, [isModalOpen]);

    return (
        <InputFileForm
            isOpen={isModalOpen}
            onClose={handleModalFileClose}
            onSubmit={handleFormSubmit}
            files={files}
            setFiles={setFiles}
            selectValues={demandTypes}
            downloadTemplateFile={fetchDemandTypeTemplateFile}
            handleChangeDemandType={handleChangeDemandType}
            errorMessage={errorMessage}
            loading={loading}
        />
    );
}

export default InputFileFormContainer;
